import { css } from '@emotion/react';
import type { ComponentPropsWithoutRef } from 'react';
import { useProgressContext } from './context';

export type ProgressLabelProps = ComponentPropsWithoutRef<'span'>;

// TODO: Review once we have Typography component
const baseStyle = css({
  fontFamily: 'var(--atlasUiFontFamilyDefault)',
  color: 'var(--color-text)',
  fontWeight: 700,
});

const largeStyle = css({
  marginTop: 'var(--spaceM)',
  fontSize: 'var(--fontSize30)',
});

const mediumStyle = css({
  marginTop: 'var(--spaceS)',
  fontSize: 'var(--fontSize20)',
});

const hideStyle = css({
  display: 'none',
});

export const ProgressLabel = ({
  children,
  ...restProps
}: ProgressLabelProps) => {
  const { labelProps, size } = useProgressContext();
  const isLarge = size === 'large';
  const isMedium = size === 'medium';
  const isSmallerThanMedium =
    size === 'small' || size === 'xsmall' || size === 'mini';

  return (
    <span
      css={[
        baseStyle,
        isLarge && largeStyle,
        isMedium && mediumStyle,
        isSmallerThanMedium && hideStyle,
      ]}
      {...labelProps}
      {...restProps}
    >
      {children}
    </span>
  );
};
